import NewTemplateModal from './NewTemplateModal';

import './NewTemplateModal.scss';

export default NewTemplateModal;
